import { render, staticRenderFns } from "./DiarieTable.vue?vue&type=template&id=0efba952&scoped=true&"
import script from "./DiarieTable.vue?vue&type=script&lang=js&"
export * from "./DiarieTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efba952",
  null
  
)

export default component.exports